module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/google-bfaedff4a6caf93fd956bb94042c4ced.svg";